/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthHistoryMedicinesListAliases {
  BUTTON_ADD_HEALTH_HISTORY_MEDICINES = 'button-add-health-history-medicines',
  CONTEXTUAL_BAR_HEALTH_HISTORY_MEDICINES = 'contextual-bar-health-history-medicines',
  DECK_HEALTH_HISTORY_MEDICINES = 'deck-health-history-medicines',
  FETCH_HEALTH_HISTORY_MEDICINES = 'fetch-health-history-medicines',
  FILTERED_LIST_HEALTH_HISTORY_MEDICINES = 'filtered-list-health-history-medicines',
  GLOBAL_ACTIONS_HEALTH_HISTORY_MEDICINES = 'global-actions-health-history-medicines',
  HEALTH_HISTORY_CARD_MEDICINES = 'health-history-card-medicines',
  LAYOUT_HEALTH_HISTORY_MEDICINES_LIST = 'layout-health-history-medicines-list',
  LEGENDS_HEALTH_HISTORY_MEDICINES = 'legends-health-history-medicines',
  PANEL_HEALTH_HISTORY_MEDICINES = 'panel-health-history-medicines',
}
export { HealthHistoryMedicinesListAliases };
